import { TypeOfTraining } from 'src/store/types';
import { TypeOfTrainingTexts } from 'src/types/company';

export const TYPE_OF_TRAINING_TEXTS: TypeOfTrainingTexts = {
  [TypeOfTraining.HIPAA_PRIME]: 'HIPAA Prime',
  [TypeOfTraining.TRAINING_ONLY]: 'Training only',
  [TypeOfTraining.CMMC]: 'NIST 800-171',
  [TypeOfTraining.GLBA]: 'GLBA',
};
